const TITLE_MAX_LENGTH = 200
const DESCRIPTION_MAX_LENGTH = 500
const NUMBER_INPUT_MAX_LENGTH = 10
export { TITLE_MAX_LENGTH, DESCRIPTION_MAX_LENGTH, NUMBER_INPUT_MAX_LENGTH }
